// ************************************************************************************************
// pathname: v2/publication/simple-calculate-price/${jobSlug}
// ************************************************************************************************
import { useTranslation } from 'next-i18next';
import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Hook props */
interface UseSwrInstantlySearchpackProps {
  locale?: Locale;
  jobSlug: string;
  packageId: string;
  onSuccess?: (data: ApiSchema<'UpgradePrice'>) => void;
}

/**
 * @description Hook for activating a searchPack.
 * - `locale`: The current app locale.
 * - `jobSlug`: The job slug.
 * - `packageId`: The id of package.
 * - `onSuccess`: Optional callback to execute on success.
 */

export const useSwrConversionCalculatePrice = (props: UseSwrInstantlySearchpackProps) => {
  const {
    jobSlug, packageId, onSuccess,
  } = props;
  const { i18n } = useTranslation('common');

  // SWR, activate the job
  return useSwrMutationApi<ApiSchema<'UpgradePrice'>, object>({
    url: `/v2/publication/simple-calculate-price/${jobSlug}?packageId=${packageId}`,
    locale: i18n.language,
    fetcherConfig: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      stringifyPayload: true,
      payload: {
        packageId,
      },
    },
    apiOptions: {
      onSuccess: (response) => {
        if (onSuccess) onSuccess(response);
      },
    },
    toastsOptions: {
      showSuccessToast: false,
      showErrorToast: true,
    },
  });
};
